import React, { useEffect } from 'react';
import { FaWifi } from 'react-icons/fa';
import useConnectionStatus from '../../hooks/useConnectionStatus';

/**
 * Shown whenever the device is offline or the live SignalR connection is down, so a stale
 * "green" agent status is never presented silently.
 */
const ConnectionBanner = () => {
	const { isOnline, isReconnecting } = useConnectionStatus();

	const visible = !isOnline || isReconnecting;

	// Reserve space at the bottom of the page so the fixed banner never covers content
	useEffect(() => {
		if (!visible) return undefined;
		document.body.classList.add('has-connection-banner');
		return () => document.body.classList.remove('has-connection-banner');
	}, [visible]);

	if (!visible) return null;

	const message = isOnline
		? 'Live connection lost — reconnecting. Agent statuses shown may be out of date.'
		: "You're offline. Agent statuses shown may be out of date.";

	return (
		<div className="connection-banner" role="status" aria-live="polite" data-testid="connection-banner">
			<FaWifi className="connection-banner__icon" />
			<span>{message}</span>
		</div>
	);
};

export default ConnectionBanner;
